import { Box, Tabs, Text, Title } from '@mantine/core';
import { LicenseLogChart } from '../components/LicenseLogChart';
import { LicenseLogsTable } from './LicenseLogsTable';
import { IconChartLine, IconTable } from '@tabler/icons-react';
import {
  LicenseLogFilterDetails,
  LicenseLogFilters,
} from '../components/LicenseLogFilters';
import { useState } from 'react';

export const LicenseLogs = () => {
  const [activeTab, setActiveTab] = useState<string | null>('chart');

  const [filters, setFilters] = useState<LicenseLogFilterDetails>({
    dateRange: [null, null],
    granularity: null,
    app: null,
    cursor: null,
    forceRefresh: 0,
  });

  const changeTab = (tab: string | null) => {
    // we need to reset cursor when switching tabs to avoid pagination issues
    setFilters({ ...filters, cursor: null });
    setActiveTab(tab);
  };

  return (
    <Box>
      <Title>License usage logs</Title>
      <Text my="md">Api authentication calls by application</Text>
      <Box>
        <Tabs value={activeTab} onChange={changeTab} keepMounted={false}>
          <Tabs.List mt="lg" mb={48}>
            <Tabs.Tab value="chart" leftSection={<IconChartLine />}>
              View chart
            </Tabs.Tab>
            <Tabs.Tab value="table" leftSection={<IconTable />}>
              View details
            </Tabs.Tab>
            <Tabs.Tab value="failure-table" leftSection={<IconTable />}>
              View failure logs
            </Tabs.Tab>
          </Tabs.List>
          <LicenseLogFilters
            filters={filters}
            onChange={setFilters}
            showGranularity={activeTab === 'chart'}
          />
          <Tabs.Panel value="chart">
            <LicenseLogChart filters={filters} />
          </Tabs.Panel>
          <Tabs.Panel value="table">
            <LicenseLogsTable
              logType="licenses"
              filters={filters}
              setFilters={setFilters}
            />
          </Tabs.Panel>
          <Tabs.Panel value="failure-table">
            <LicenseLogsTable
              logType="failures"
              filters={filters}
              setFilters={setFilters}
            />
          </Tabs.Panel>
        </Tabs>
      </Box>
    </Box>
  );
};
